export const IsLocal = () => {
	return !process.env.APP_ENV || process.env.APP_ENV === 'Local';
};

export const IsDevelopment = () => {
	return !process.env.APP_ENV || process.env.APP_ENV === 'Development';
};

export const IsStaging = () => {
	return process.env.APP_ENV && process.env.APP_ENV === 'Staging';
};

export const IsProduction = () => {
	return process.env.APP_ENV && process.env.APP_ENV === 'Production';
};

export const baseEndpointUri = process.env.API_URL;
